/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useRef, useState} from 'react'
import {
    SortingState,
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'
import React from 'react'
import {Modal} from 'react-bootstrap'
import notifyToast from '../../components/Toast/Toast'
import {KTCard, KTCardBody, KTIcon} from '../../../_websoft/helpers'
import {TableActionButton} from '../../components/TableActionBtn/TableActionButton'
import {Link, useNavigate} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import TableSearch from '../../components/TableSearch/TableSearch'
import ExportButton from '../../components/TableExportToExcel/ExportButton'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import TablePagination from '../../components/TablePagination/TablePagination'
import {PaginationModel} from '../../models/PaginationModel'
import {ThermoBoardNalozi} from '../../models/ThermoBoardNalozi'
import {
    arhivirajIsporuceneNaloge,
    deleteTBNalog,
    getAllNalozi,
    getPakingListeThermoboard,
} from '../../api/thermoboardNalozi'
import ThermoBoardPakModal from './components/ThermoBoardPakModal/ThermoBoardPakModal'
import QRCode from 'qrcode'
import {usePDF} from '@react-pdf/renderer'
import ThermoboardPakingListePdf from '../../components/QrCodeGenerator/ThermoboardPakingListePdf'
import moments from 'moment/moment'
import ThermoBoardKreirajPaketeModal from './components/ThermoBoardKreirajPaketeModal/ThermoBoardKreirajPaketeModal'

export type ThermoBoardListaProps = {
    hideDodajButton?: boolean
    hidePdfColumn?: boolean
    hideKreirajPaketeColumn?: boolean
    hideAkcijaColumn?: boolean
}

function ThermoBoardLista({
    hideDodajButton = false,
    hidePdfColumn = false,
    hideKreirajPaketeColumn = false,
    hideAkcijaColumn = false,
}: ThermoBoardListaProps) {
    const [data, setData] = useState<ThermoBoardNalozi[]>([])
    const [loading, setLoading] = useState(true)
    const [pagination, setpagination] = useState<PaginationModel>({
        curPage: 1,
        totalPage: 1,
        perPage: 10,
    })
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isModalOpen, setisModalOpen] = useState(false)
    const [selectedNalogId, setselectedNalogId] = useState()
    const [params, setParams] = useState({
        page: 1,
        per_page: 10,
        tipPanela: undefined,
        komercijalista: undefined,
    })

    const [sorting, setSorting] = useState<SortingState>([])
    const [globalFilter, setGlobalFilter] = React.useState('')
    const [qrList, setqrList] = useState<string[]>()
    const [archiveLoading, setArchiveLoading] = useState(false)
    const [isKreirajPaketeModalOpen, setIsKreirajPaketeModalOpen] = useState(false)
    const [selectedVrsta, setSelectedVrsta] = useState<string | number>('')
    const [selectedKreirajPaketeNalogId, setSelectedKreirajPaketeNalogId] = useState<string | number>(
        ''
    )
    const [isPakingListeModalOpen, setIsPakingListeModalOpen] = useState(false)
    const [pakingListeLoading, setPakingListeLoading] = useState(false)
    const [pakingListeRange, setPakingListeRange] = useState({
        firstId: '',
        lastId: '',
    })
    const pakingListeWindowRef = useRef<Window | null>(null)
    const updatePage = () => {
        setLoading(true)
        getAllNalozi(params)
            .then((response) => {
                const data = response.data['data']
                setData(data)
                const totalPage = Math.floor(response.data['total'] / response.data['per_page'] + 1)
                setpagination({
                    curPage: response.data['current_page'],
                    totalPage: totalPage,
                    perPage: params.per_page,
                })
            })
            .catch((error) => {
                console.error('Error: ', error)
                notifyToast(false, error)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const handlePakingListeBtnClick = () => {
        setPakingListeRange({firstId: '', lastId: ''})
        setIsPakingListeModalOpen(true)
    }

    const handlePakingListeModalClose = () => {
        setIsPakingListeModalOpen(false)
        setPakingListeRange({firstId: '', lastId: ''})
    }

    const kreirajPakingListe = (firstId: string | number, lastId: string | number) => {
        if (!firstId || !lastId) {
            notifyToast(false, 'Unesite prvi i zadnji ID paketa.')
            return
        }

        pakingListeWindowRef.current = window.open('', '_blank')
        setPakingListeLoading(true)
        const params = {
            firstId,
            lastId,
        }

        getPakingListeThermoboard(params)
            .then(async (response) => {
                const pdfStarted = await convertQrSvgToImg(response.data['data'])

                if (pdfStarted) {
                    notifyToast(true, 'Success')
                    setIsPakingListeModalOpen(false)
                }
            })
            .catch((error) => {
                console.error('Error: ', error)
                notifyToast(false, error.response?.data?.message || 'An error occurred')
            })
            .finally(() => setPakingListeLoading(false))
    }

    const handlePakingListeModalSubmit = () => {
        kreirajPakingListe(pakingListeRange.firstId, pakingListeRange.lastId)
    }

    const getVrstaLabel = (row: any) => row?.tip_panela?.Naziv || row?.tip_panela?.naziv || ''

    const openKreirajPaketeModal = (row: ThermoBoardNalozi) => {
        setSelectedVrsta(getVrstaLabel(row))
        setSelectedKreirajPaketeNalogId(row.Id)
        setIsKreirajPaketeModalOpen(true)
    }

    const convertQrSvgToImg = async (pakingListe) => {
        if (!Array.isArray(pakingListe) || !pakingListe.length) {
            pakingListeWindowRef.current?.close()
            pakingListeWindowRef.current = null
            notifyToast(false, 'Nema paking listi za odabrani raspon paketa.')
            return false
        }

        var list: Array<string> = []
        console.log('paking', pakingListe)
        list = await Promise.all(pakingListe.map((item) => QRCode.toDataURL(item.qrcode)))
        setqrList(list)
        updateInstance(<ThermoboardPakingListePdf qrData={pakingListe} qrList={list}/>)
        return true
    }

    const [instance, updateInstance] = usePDF({})

    // Open Pdf when intance link is generated.
    useEffect(() => {
        if (!instance.loading && instance.url && qrList?.length) {
            if (pakingListeWindowRef.current && !pakingListeWindowRef.current.closed) {
                pakingListeWindowRef.current.location.href = instance.url
                pakingListeWindowRef.current.focus()
                pakingListeWindowRef.current = null
                return
            }

            window.open(instance.url, '_blank')?.focus()
        }
    }, [instance, qrList])

    useEffect(() => {
        updatePage()
    }, [params])

    useEffect(() => {
        const {id} = sorting[0] ?? ''
        data.sort((a, b) => a[id] - b[id])
    }, [sorting])

    const columns = [
        {
            id: 'Id',
            header: 'Id',
            accessorKey: 'Id',
        },
        {
            id: 'Naziv',
            header: 'Naziv',
            cell: () => <span>Interni nalog</span>,
        },
        {
            id: 'Vrsta TB',
            header: 'Vrsta TB',
            accessorKey: 'tip_panela.Naziv',
        },
        {
            id: 'Proizvedeno',
            header: 'Proizvedeno',
            accessorKey: 'ProizvedenoPaketaCount',
        },
        {
            id: 'Isporučeno',
            header: 'Isporučeno',
            accessorKey: 'IsporucenoPaketaCount',
        },
        {
            id: 'Proizvesti',
            header: 'Proizvesti',
            accessorKey: 'ZaProizvestiPaketaCount',
        },
        {
            id: 'Stanje',
            header: 'Stanje',
            cell: ({row}) => {
                // Perform subtraction here
                const total = row.original.ProizvedenoPaketaCount - row.original.IsporucenoPaketaCount
                return <div>{total}</div>
            },
        },
        {
            id: 'Raspolozivo',
            header: 'Raspoloživo',
            accessorKey: 'RaspolozivoM2',
            cell: ({getValue}) => {
                const value = Number(getValue())
                return Number.isFinite(value) ? value.toFixed(2) : '0.00'
            },
        },
        {
            id: 'Rezervisano',
            header: 'Rezervisano',
            accessorKey: 'rezervisanaKolicinaNaloga',
        },
        {
            id: 'Datum',
            header: 'Datum',
            accessorFn: (row) => `${moments(row.Kreirano).format('DD-MM-YYYY')}`,
        },
        {
            id: 'Napomena',
            header: 'Napomena',
            accessorKey: 'napomena',
        },
        {
            id: 'Paketi',
            header: 'Paketi',
            cell: ({row}) => (
                <div
                    className='btn btn-sm btn-light-primary fw-bold'
                    onClick={() => {
                        setselectedNalogId(row.original.Id)
                        setisModalOpen(true)
                    }}
                >
                    Paketi
                </div>
            ),
        },
        !hidePdfColumn && {
            id: 'pdf',
            header: 'pdf',
            cell: ({row}) => (
                <button
                    type='button'
                    className='btn btn-sm btn-icon btn-light-info'
                    onClick={() => {
                        handlePakingListeBtnClick()
                    }}
                >
                    <KTIcon iconName={'document'} className='fs-2'/>
                </button>
            ),
        },
        !hideKreirajPaketeColumn && {
            id: 'Kreiraj pakete',
            header: 'Paketi',
            cell: ({row}) => (
                <button
                    type='button'
                    className='btn btn-sm btn-light-primary fw-bold'
                    onClick={() => openKreirajPaketeModal(row.original)}
                >
                    <KTIcon iconName='plus' className='fs-3'/>
                    Paketi
                </button>
            ),
        },
        !hideAkcijaColumn && {
            header: 'Akcija',
            accessorKey: 'Akcija',
            cell: ({row}) => (
                <TableActionButton
                    onDelete={() => onDelete(row.original.Id)}
                    onEdit={() => {
                        onEdit(row.original.Id)
                    }}
                />
            ),
        },
    ].filter(Boolean) as any[]
    const table = useReactTable({
        data: data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        state: {
            sorting: sorting,
            globalFilter: globalFilter,
        },
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        onSortingChange: setSorting,
    })
    const onDelete = (id: number) => {
        deleteTBNalog(id)
            .then((response) => {
                if (response.error === 0) {
                    notifyToast(true, response.message)
                    updatePage()
                } else {
                    notifyToast(false, response.message)
                }
            })
            .catch((error) => {
                notifyToast(false, error.message)
            })
    }
    const navigate = useNavigate()

    const onEdit = (rowData) => {
        navigate(`/thermoboard/izmjena/${rowData}`)
    }

    return (
        <KTCard>
            <ToastContainer/>
            <ThermoBoardPakModal
                isModalOpen={isModalOpen && selectedNalogId}
                setisModalOpen={setisModalOpen}
                idNaloga={selectedNalogId}
            />
            <ThermoBoardKreirajPaketeModal
                isOpen={isKreirajPaketeModalOpen}
                onClose={() => setIsKreirajPaketeModalOpen(false)}
                vrsta={selectedVrsta}
                idNaloga={selectedKreirajPaketeNalogId}
                onSuccess={updatePage}
                onCreatePakingListe={kreirajPakingListe}
            />
            <Modal show={isPakingListeModalOpen} onHide={handlePakingListeModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title className='fw-bold'>Kreiraj paking liste</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className='text-muted fw-semibold mb-5'>
                        Unesite raspon ID paketa za koje zelite generisati paking liste.
                    </div>

                    <div className='row g-5'>
                        <div className='col-md-6'>
                            <label className='form-label fw-bold'>Prvi paket ID</label>
                            <input
                                type='number'
                                min='1'
                                step='1'
                                className='form-control form-control-lg form-control-solid'
                                value={pakingListeRange.firstId}
                                onChange={(event) =>
                                    setPakingListeRange((prev) => ({...prev, firstId: event.target.value}))
                                }
                                placeholder='npr. 164'
                            />
                        </div>

                        <div className='col-md-6'>
                            <label className='form-label fw-bold'>Zadnji paket ID</label>
                            <input
                                type='number'
                                min='1'
                                step='1'
                                className='form-control form-control-lg form-control-solid'
                                value={pakingListeRange.lastId}
                                onChange={(event) =>
                                    setPakingListeRange((prev) => ({...prev, lastId: event.target.value}))
                                }
                                placeholder='npr. 171'
                            />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button
                        type='button'
                        className='btn btn-light'
                        onClick={handlePakingListeModalClose}
                        disabled={pakingListeLoading}
                    >
                        Zatvori
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary fw-bold'
                        onClick={handlePakingListeModalSubmit}
                        disabled={pakingListeLoading}
                    >
                        {pakingListeLoading ? (
                            <>
                                <span className='spinner-border spinner-border-sm me-2'/>
                                Generisanje...
                            </>
                        ) : (
                            'Kreiraj paking liste'
                        )}
                    </button>
                </Modal.Footer>
            </Modal>

            <KTCardBody className='py-6'>
                <div className='rounded bg-light p-5 mb-6'>
                    <div className='d-flex flex-column flex-xl-row justify-content-between gap-5'>
                        <div>
                            <h3 className='fs-4 fw-bold text-gray-900 mb-1'>Thermoboard nalozi</h3>
                            <div className='text-muted fw-semibold fs-7'>
                                Pregled internih naloga proizvodnje TB Ploca.
                            </div>
                        </div>

                        <div className='d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-3'>

                            {!hideDodajButton && (
                                <Link to='/thermoboard/dodaj'>
                                    <button type='button' className='btn btn-primary fw-bold w-100'>
                                        <KTIcon iconName='plus' className='fs-2'/>
                                        Dodaj
                                    </button>
                                </Link>
                            )}
                        </div>
                    </div>

                    <div className='separator separator-dashed my-5'/>
                </div>

                <div
                    className='d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-4 mb-4'>
                    <div data-kt-user-table-toolbar='base' className='w-100 w-md-auto'>
                        <TableSearch onSearch={(text) => setGlobalFilter(text)}/>
                    </div>

                    <div data-kt-user-table-toolbar='base' className='d-flex justify-content-md-end'>
                        <ExportButton table={table} filename={'thermoboard_nalozi'}/>
                    </div>
                </div>

                {loading ? (
                    <LoadingComponent/>
                ) : (
                    <div className='table-responsive mt-3 border rounded'>
                        <table className='table table-row-bordered table-row-gray-200 align-middle gy-4 mb-0 no-footer'>
                            <thead>
                            {table.getHeaderGroups().map((headerGroup) => (
                                <tr
                                    key={headerGroup.id}
                                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'
                                >
                                    {headerGroup.headers.map((header) => (
                                        <th
                                            className='text-white ps-4'
                                            key={header.id}
                                            onClick={header.column.getToggleSortingHandler()}
                                        >
                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                            {/* @ts-ignore */}
                                            {{asc: '🔼', desc: '🔽'}[header.column.getIsSorted() ?? null]}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>
                            <tbody className='text-gray-600'>
                            {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                                table.getRowModel().rows.map((row) => (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map((cell) => (
                                            <td key={cell.id} className='ps-4'>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7}>
                                        <div
                                            className='d-flex text-center w-100 align-content-center justify-content-center'>
                                            No matching records found
                                        </div>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                )}
                <TablePagination
                    updatePage={(page, per_page) =>
                        setParams((prev) => ({
                            ...prev,
                            page,
                            per_page,
                        }))
                    }
                    pagination={pagination}
                />
            </KTCardBody>
        </KTCard>
    )
}
export default ThermoBoardLista
